// extracted by mini-css-extract-plugin
module.exports = {"movieBtn":"MovieBtn_movieBtn__zuA3X","text":"MovieBtn_text__lEVGd"};